import {Component} from '@angular/core';
import {MoovementSvgComponent} from "src/app/presentation/common/icons/moovement-svg/moovement-svg.component";
import {RoutingService} from 'src/app/infrastructure/routing/routing.service';

@Component({
  selector: 'app-grazing-patterns-button',
  imports: [
    MoovementSvgComponent
  ],
  templateUrl: './grazing-patterns-button.component.html',
  styleUrl: './grazing-patterns-button.component.css'
})
export class GrazingPatternsButtonComponent {

  constructor(
    protected routingService: RoutingService
  ) {}
}
